import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDelete",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(l).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], m = ["id"];
function _(a, t, r, h, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--delete"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Delete",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`,
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      e("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.147 2.147A.5.5 0 0 1 4.5 2H10a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 10H4.5a.5.5 0 0 1-.353-.146l-3.5-3.5a.5.5 0 0 1 0-.707l3.5-3.5Zm.56.853-3 3 3 3H10a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 3H4.707Z"
      }, null, -1),
      e("path", { d: "M9.354 4.147a.5.5 0 0 1 0 .707L8.207 6l1.147 1.147a.5.5 0 0 1-.707.707L7.5 6.707 6.354 7.854a.5.5 0 0 1-.707-.707L6.793 6 5.647 4.854a.5.5 0 0 1 .707-.707L7.5 5.293l1.147-1.146a.5.5 0 0 1 .707 0Z" }, null, -1)
    ])], 8, f),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...t[1] || (t[1] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, p);
}
const D = /* @__PURE__ */ u(c, [["render", _]]);
export {
  D as default
};
//# sourceMappingURL=delete.js.map
